import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable()
export class AppChildRouteGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dataservice: DataService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const isLoggedIn = this.authService.getIsLoggedIn();
    const dataLoaded = this.dataservice.loaded;

    // console.log('in auth guard');
    if (!isLoggedIn) {
      // console.log('not logged in');
      this.router.navigate(['sdp/signin']);
    }
    if (state.url.indexOf('sdp/forms/') > -1) {
      if (!dataLoaded) {
        // console.log('data not loaded');
        this.router.navigate(['sdp/loading']);
      }
    }

    return state.url.indexOf('sdp/forms/') > -1
      ? isLoggedIn && dataLoaded
      : isLoggedIn;
  }
}
